import { useEffect, useRef, useState } from "react"
import { useAuth } from "../contexts/AuthContext"
import { useOutletContext } from "react-router-dom"
import WorkspaceSubscriptions from "../components/billing-settings/WorkspaceSubscriptions";
import Transactions from "../components/billing-settings/Transactions";
import UpdateBilling from "../components/billing-settings/UpdateBilling";
import Security from "../components/account-settings/Security";
import Deletion from "../components/account-settings/Deletion";
import YourAccount from "../components/account-settings/YourAccount";
import { useLanguage } from '../contexts/LanguageContext';
import { useTranslation } from '../hooks/useTranslation';
import CustomerBalance from "../components/billing-settings/CustomerBalance";

export default function Settings() {
    const t = useTranslation();
    const { currentLang, setCurrentLang } = useLanguage();
    const { url, logout, getAuthProvider, lastLoginWithin } = useAuth()
    const { cardData, getCardData, invoiceData, getInvoiceData, clientData } = useOutletContext();

    const [settingContent, setSettingContent] = useState("Account");

    const [isReauthed, setIsReauthed] = useState(lastLoginWithin(10)); // 10 mins

    const props = {
        invoices: invoiceData,
        url,
        paymentMethod: cardData && cardData.length > 0 ? cardData[0] : null,
        getCardData,
        getInvoiceData,
        getAuthProvider,
        isReauthed,
        stripeCustomerId: clientData?.stripeCustomerId,
        setIsReauthed,
    };

    function getSettingContent() {
        switch (settingContent) {
            case "Account":
                return <AccountSettings {...props} />;
            case "Billing":
                return <BillingSettings {...props} />;
            default:
                return <AccountSettings {...props} />;
        }
    }

    return (
        <div className="settings-page">
            <div className="justify-content-center">
                <div className="col-auto">
                    <div className="settings-tab-bar">
                        <button className={`settings-tab-button${settingContent === "Account" ? " selected" : ""}`} onClick={() => setSettingContent("Account")}>{t('Account')}</button>
                        <button className={`settings-tab-button${settingContent === "Billing" ? " selected" : ""}`} onClick={() => setSettingContent("Billing")}>{t('Billing')}</button>
                        <button className="settings-tab-button sign-out" onClick={logout}>{t('Sign Out')}</button>
                    </div>
                </div>
            </div>
            <div className="row">
                {getSettingContent()}
            </div>
            {/*<div>
                <select value={currentLang} onChange={e => setCurrentLang(e.target.value)}>
                    <option value="en-us">English</option>
                    <option value="es">Español</option>
                </select>
            </div>*/}
        </div>
    );
}

function AccountSettings({ getAuthProvider, isReauthed, setIsReauthed }) {
    return ( 
        <>
            <YourAccount isReauthed={isReauthed} setIsReauthed={setIsReauthed} />
            {getAuthProvider() === "password" && <Security isReauthed={isReauthed} setIsReauthed={setIsReauthed} />}
            <Deletion isReauthed={isReauthed} setIsReauthed={setIsReauthed} />
        </>
    );
}

function BillingSettings({ invoices, paymentMethod, getCardData, getInvoiceData, stripeCustomerId, ...rest }) {
    useEffect(() => {
        if (!paymentMethod) {
            getCardData();
        }
        if (!invoices || invoices.length === 0) {
            getInvoiceData();
        }
    }, [paymentMethod, invoices]);

    return (
        <>
            <UpdateBilling paymentMethod={paymentMethod} getCardData={getCardData} {...rest} />
            <WorkspaceSubscriptions />
            <Transactions invoices={invoices} getInvoiceData={getInvoiceData} />
            {stripeCustomerId && <CustomerBalance stripeCustomerId={stripeCustomerId} />}
        </>
    );
}